var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureSub2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 164158",
    transform: "translate(-1396 -6041)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 9445",
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1396 6041)",
    style: {
      opacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.35 44.15-7.15-7.1a6.685 6.685 0 0 1-1.9 1.05 6.311 6.311 0 0 1-2.1.35 6.231 6.231 0 0 1-6.25-6.25 6.231 6.231 0 0 1 6.25-6.25 6.231 6.231 0 0 1 6.25 6.25 6.28 6.28 0 0 1-.375 2.175 5.859 5.859 0 0 1-1.125 1.875l7.2 7.1zm-11.15-6.8a5.162 5.162 0 0 0 3.65-8.8 5.162 5.162 0 0 0-7.3 7.3 4.968 4.968 0 0 0 3.65 1.5zm-27.55-3.1-.9-.7 8.2-13.15 6 7 7.9-12.75 3.7 5.6a4.845 4.845 0 0 1-.525.175q-.275.075-.525.125l-2.6-3.85-7.7 12.55-6.05-7.05zm30.8-13.9a2.552 2.552 0 0 0-.575-.125 4.973 4.973 0 0 1-.525-.075l9-14.3.9.7z",
    transform: "translate(1416.25 6060.15)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureSub2);
export default __webpack_public_path__ + "static/media/feature-sub-2.83edf2db5875e348185aca0f772a87d5.svg";
export { ForwardRef as ReactComponent };